class YtVideoModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.handleEscape = this.handleEscape.bind(this);
  }

  connectedCallback() {
    this.videoId = this.dataset.videoId;
    if (!this.videoId) {
      this.style.display = 'none';
      return;
    }

    this.playBtn = this.querySelector('.yt-video-modal__play-btn-wrapper');
    this.overlay = this.querySelector('.yt-video-modal__overlay');
    this.closeBtn = this.querySelector('.yt-video-modal__close');
    this.videoContainer = this.querySelector('.yt-video-modal__video-container');

    this.playBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.open();
    });

    this.closeBtn.addEventListener('click', () => this.close());

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.close();
      }
    });
  }

  open() {
    this.isOpen = true;
    document.body.appendChild(this.overlay);
    this.overlay.style.display = 'flex';

    const embedUrl = `https://www.youtube.com/embed/${this.videoId}?si=AVQ9yk8tbyO4MGPc&rel=0&modestbranding=1&autoplay=1&enablejsapi=1&controls=0&loop=1`;

    this.videoContainer.innerHTML = `
      <iframe
        class="yt-video-modal__iframe"
        src="${embedUrl}"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        title="YouTube video player"
      ></iframe>
    `;

    document.addEventListener('keydown', this.handleEscape);
  }

  close() {
    this.isOpen = false;
    this.overlay.style.display = 'none';
    this.videoContainer.innerHTML = '';
    this.appendChild(this.overlay);
    document.removeEventListener('keydown', this.handleEscape);
  }

  handleEscape(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.close();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleEscape);
  }
}

if (!customElements.get('yt-video-modal')) {
  customElements.define('yt-video-modal', YtVideoModal);
}
